import { useState } from "react";
import { PrimaryButton } from "../../Shared/Buttons";
import ReqEdit from "../NewReqEdit/ReqEdit";

const NewRequestDetails = ({ id }) => {
  const [modalItemId, setModalItemId] = useState("");
  const [openModal, setopenModal] = useState(false);
  const handleClose = () => {
    setopenModal(!openModal);
  };
  const handleModal = (id) => {
    setModalItemId(id);
    setopenModal(true);
  };
  return (
    <>
      {openModal && (
        <ReqEdit
          open={openModal}
          handleClose={handleClose}
          id={modalItemId}
          top={100}
          topMobile={100}
          width={700}
          minHeight={400}
        />
      )}
      <PrimaryButton
        size="small"
        style={{ width: "100px" }}
        handleClick={() => handleModal(id)}
        testId={`new_req_${id}`}
      >
        DETAILS
      </PrimaryButton>
    </>
  );
};
export default NewRequestDetails;
